module.exports = __webpack_public_path__ + "static/img/03.dba6fcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/alpa_bern/03.jpg
// module id = 352
// module chunks = 1